export { default as useCollaborationSidebarState } from 'collaboration-sidebar/hooks/useCollaborationSidebarState';